<template>
  <dl
    class="icon-details-aliases display-inline-flex flex-items-center"
    style="--margin-bottom: 0; --padding-left: 0; gap: var(--spacing-md)"
  >
    <dt
      class="muted sr-only"
      style="--margin-bottom: 0; font-weight: var(--font-weight-normal)"
    >
      {{ aliasLabel }}:
    </dt>
    <dd
      v-for="alias in aliases"
      :key="alias"
      style="--margin-bottom: 0"
    >
      <span
        class="tag teal rounded text-select-all"
        style="--tag-letter-spacing: 0; --tag-text-transform: none"
      >
        <span
          class="text-lowercase"
          style="letter-spacing: 0.0625em"
          >{{ alias }}</span
        >
      </span>
    </dd>
  </dl>
</template>

<script>
  export default {
    name: 'IconAliases',

    props: {
      aliases: {
        type: Array,
        required: true
      }
    },

    computed: {
      aliasLabel() {
        if (this.aliases.length === 0) {
          return 'Alias'
        } else {
          return 'Aliases'
        }
      }
    }
  }
</script>
